export function initDashboardTable() {
    const tableSelector = "#dashboard-table";

    if (!window.jQuery || !window.jQuery.fn?.dataTable) {
        console.warn("DataTables: jQuery not available yet.");
        return;
    }

    const $table = window.jQuery(tableSelector);
    const tableEl = $table.get(0);
    if (!tableEl || !tableEl.isConnected || !tableEl.parentNode) {
        return;
    }

    if (!tableEl.tHead || !tableEl.tBodies || !tableEl.tBodies.length) {
        return;
    }

    try {
        if (window.dashboardDataTable) {
            const existingNode = window.dashboardDataTable.table()?.node?.();
            if (!existingNode || !existingNode.isConnected) {
                window.dashboardDataTable = null;
            }
        }

        if (window.jQuery.fn.dataTable.isDataTable(tableEl)) {
            return;
        }

        window.dashboardDataTable = $table.DataTable({
            paging: false,
            order: [[0, "asc"]],
            autoWidth: false,
            language: {
                url: "/assets/datatables/i18n/fr-FR.json",
                lengthMenu: "_MENU_ entrées par page",
                paginate: {
                    first: "«",
                    previous: "<",
                    next: ">",
                    last: "»",
                },
            },
            columnDefs: [
                {
                    orderable: false,
                    searchable: false,
                    targets: [13],
                },
            ],
            dom: "f",
            fixedHeader: true,
        });
    } catch (error) {
        console.warn("DataTables init failed", error);
    }
}
